import { useSelector } from 'react-redux';
import { MARKET_MODES } from '../../../../constans';
import { CheckButton } from '../../../Basic/Buttons';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../Basic/Table';
import MarketsLine from './Line';
import styles from './styles.module.scss';

const WIDTH_MARKETPLACE = [
  '110px', //0
  '160px', //1
  '400px', //2
  '100px', //3
  '100px', //4
  '60px', //5
  '150px', //6
  '160px', //7
  '200px', //8
  '150px', //9
  '40px', //10
  '170px', //11
  '120px', //12
  '70px', //13
  '30px', //14
];

const MarketsTable = ({
  shopsWbInfo,
  marketInfo,
  pricesMode,
  sizesMode,
  market = '',
  count = 1,
  show = 50,
  page = 1,
  cards = [],
  productsSelect,
  isExpress = false,
  isOwner = false,
  checkAll = false,
  clickCheckAll = (_) => _,
  changeProductSelect = (_) => _,
  onChangePage = (_) => _,
  onChangeProduct = (_) => _,
  printSticker = (_) => _,
  selectTab,
  contentMode = 0,
}) => {
  const packageMethods = useSelector((store) => store.packaging);

  return (
    <>
      <Table styles={styles.table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={WIDTH_MARKETPLACE[4]}>
            <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
          </HeaderTitle>

          <HeaderTitle width={WIDTH_MARKETPLACE[1]}>Артикул</HeaderTitle>
          {contentMode !== MARKET_MODES[3] && <HeaderTitle width={WIDTH_MARKETPLACE[12]}>Бренд</HeaderTitle>}
          <HeaderTitle width={WIDTH_MARKETPLACE[2]}>Название товара</HeaderTitle>
          {selectTab === 'error' && <HeaderTitle width={WIDTH_MARKETPLACE[2]}>Ошибка</HeaderTitle>}
          {selectTab === 'warning' && <HeaderTitle width={WIDTH_MARKETPLACE[2]}>Предупреждение</HeaderTitle>}

          {[MARKET_MODES[0], MARKET_MODES[3]].includes(contentMode) && (
            <>
              {contentMode === MARKET_MODES[3] && (
                <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
                  Всего закуплено
                </HeaderTitle>
              )}
              <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
                Остаток
              </HeaderTitle>
              {contentMode === MARKET_MODES[3] && (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[8]} style={{ fontSize: 10 }} centerText={true}>
                    Доставляется/Продано/Отменено/Возврат/Отправили
                  </HeaderTitle>
                  {isOwner && (
                    <HeaderTitle width={WIDTH_MARKETPLACE[6]} centerText={true}>
                      Прибыль
                    </HeaderTitle>
                  )}
                  {pricesMode && (
                    <>
                      <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText={true}>
                        Цена продажи
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText={true}>
                        Цена закупки
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[6]} centerText={true}>
                        Профит
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[13]} centerText>
                        Марж.
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[13]} centerText style={{ fontSize: 10 }}>
                        Мин. прибыль
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[14]} centerText style={{ fontSize: 10 }}></HeaderTitle>
                    </>
                  )}
                  {/* <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>Доставляется/Продано/Отменено/Возврат/Отправили</HeaderTitle> */}
                </>
              )}
              {/* <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>Остаток Екб</HeaderTitle> */}
              {selectTab === 'warehouse' && (
                <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                  Остаток на складе Мск
                </HeaderTitle>
              )}
              {selectTab === 'warehouse' && (
                <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                  Остаток на складе Екб
                </HeaderTitle>
              )}
              {selectTab === 'mpwarehouse' && (
                <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                  Остаток на складе МП
                </HeaderTitle>
              )}
              {isExpress && (
                <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText styles={styles.express_color}>
                  Остаток Express
                </HeaderTitle>
              )}
            </>
          )}

          {(contentMode === MARKET_MODES[0] || contentMode === MARKET_MODES[1]) && (
            <>
              {market !== 'KUPER' && market !== 'B-WHITE' && (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[7]} centerText>
                    {market === 'YANDEX' ? 'Цена за 1 шт / квант' : 'Цена / Цена до скидки'}
                  </HeaderTitle>
                </>
              )}

              {market === 'KUPER' && (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
                    Цена
                  </HeaderTitle>
                </>
              )}
              {isOwner && (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
                    Цена закупки
                  </HeaderTitle>
                  {market === 'WB' && (
                    <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
                      Скидка
                    </HeaderTitle>
                  )}

                  {contentMode === MARKET_MODES[1] && (
                    <>
                      <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText style={{ fontSize: 9 }}>
                        Маржинальность
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText style={{ fontSize: 10 }}>
                        Минимальная прибыль
                      </HeaderTitle>
                    </>
                  )}

                  <HeaderTitle width={WIDTH_MARKETPLACE[6]} centerText>
                    Прибыль / Комиссия
                  </HeaderTitle>
                  {isOwner && isExpress && market !== 'WB' && (
                    <>
                      <HeaderTitle width={WIDTH_MARKETPLACE[6]} centerText styles={styles.express_color}>
                        Прибыль / Комиссия express
                      </HeaderTitle>
                    </>
                  )}
                  {contentMode === MARKET_MODES[1] && (
                    <>
                      <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
                        Ставка НДС
                      </HeaderTitle>
                    </>
                  )}
                </>
              )}
            </>
          )}
          {(contentMode === MARKET_MODES[2] || sizesMode) && (
            <>
              <HeaderTitle width={WIDTH_MARKETPLACE[8]} centerText>
                Способ упаковки
              </HeaderTitle>
              {market === 'WB' || market === 'YANDEX' ? (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Ширина, см
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Высота, см
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Длина, см
                  </HeaderTitle>
                  {market === 'YANDEX' && (
                    <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                      Вес, кг
                    </HeaderTitle>
                  )}
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Объем, л
                  </HeaderTitle>
                </>
              ) : (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Ширина, мм
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Высота, мм
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Длина, мм
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Вес, кг
                  </HeaderTitle>
                  {market === 'YANDEX' ? (
                    <>
                      <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                        Объемный вес
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                        Вес за квант
                      </HeaderTitle>
                    </>
                  ) : (
                    <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                      Объем, л
                    </HeaderTitle>
                  )}
                </>
              )}
              {!sizesMode && (
                <>
                  <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>
                    Стоимость доставки
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_MARKETPLACE[6]} centerText>
                    Прибыль / Комиссия
                  </HeaderTitle>
                </>
              )}
            </>
          )}
          {/* {market === 'YANDEX' && (
            <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
              Квант продажи
            </HeaderTitle>
          )} */}
          {contentMode !== MARKET_MODES[3] && (
            <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
              Количество продаж
            </HeaderTitle>
          )}
          <HeaderTitle width={WIDTH_MARKETPLACE[11]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[7]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
            Количество в заказе
          </HeaderTitle>
          {contentMode !== MARKET_MODES[3] && (
            <HeaderTitle width={WIDTH_MARKETPLACE[7]} centerText>
              Артикул на складе
            </HeaderTitle>
          )}
          {isOwner && contentMode !== MARKET_MODES[3] && (
            <>
              <HeaderTitle width={WIDTH_MARKETPLACE[0]} />
              <HeaderTitle width={WIDTH_MARKETPLACE[9]}>Дата обновления остатка</HeaderTitle>
            </>
          )}
        </TableHeader>
        {cards.ids.map((key) => (
          <MarketsLine
            packageMethods={packageMethods}
            sizesMode={sizesMode}
            pricesMode={pricesMode}
            market={market}
            contentMode={contentMode}
            key={cards.byId[key].offer_id}
            isOwner={isOwner}
            isExpress={isExpress}
            item={cards.byId[key]}
            selectTab={selectTab}
            productsSelect={productsSelect}
            changeProductSelect={changeProductSelect}
            onChangeProduct={onChangeProduct}
            printSticker={printSticker}
          />
        ))}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </>
  );
};

export default MarketsTable;
